// Import images so they get added to the clientlibs directory upon webpack compilation.
// TODO: Import these from TDS.

// Dots.
import iconDotDarkGrey from '../static/img/icon-dot--dark_grey.png';
import iconDotGrey from '../static/img/icon-dot--grey.png';
import iconDotRed from '../static/img/icon-dot--red.png';
import iconDotWhite from '../static/img/icon-dot--white.png';

// Store icons.
import iconStore from '../static/img/icon-store.png';
import iconStoreSelected from '../static/img/icon-store--selected.png';
import iconStoreUpcoming from '../static/img/icon-store--upcoming.png';

// Service center icons.
import iconService from '../static/img/icon-service.png';
import iconServiceSelected from '../static/img/icon-service--selected.png';
import iconServiceUpcoming from '../static/img/icon-service--upcoming.png';

// Supercharger icons.
import iconSupercharger from '../static/img/icon-supercharger.png';
import iconSuperchargerSelected from '../static/img/icon-supercharger--selected.png';
import iconSuperchargerUpcoming from '../static/img/icon-supercharger--upcoming.png';

// Destination charger icons.
import iconDestinationCharger from '../static/img/icon-destinationcharger.png';
import iconDestinationChargerSelected from '../static/img/icon-destinationcharger--selected.png';
import iconDestinationChargerUpcoming from '../static/img/icon-destinationcharger--upcoming.png';

export default {
  default: {
    types: {
      default: iconDotWhite,
      selected: iconDotWhite,
      upcoming: iconDotWhite,
      pin: 'tsla-icon-badge-pin',
      dot: iconDotWhite,
      dotSelected: iconDotWhite,
    },
    size: {
      marker: {
        height: 10,
        width: 10,
      },
      dot: {
        height: 5,
        width: 5,
      },
    },
  },
  supercharger: {
    types: {
      default: iconSupercharger,
      selected: iconSuperchargerSelected,
      upcoming: iconSuperchargerUpcoming,
      pin: 'tsla-icon-bolt-pin-red',
      dot: iconDotRed,
      dotSelected: iconDotDarkGrey,
    },
    size: {
      marker: {
        height: 23,
        width: 33,
      },
      dot: {
        height: 5,
        width: 5,
      },
      selected: {
        height: 36,
        width: 52,
      },
    },
  },
  'destination charger': {
    types: {
      default: iconDestinationCharger,
      selected: iconDestinationChargerSelected,
      upcoming: iconDestinationChargerUpcoming,
      pin: 'tsla-icon-bolt-pin-dark',
      dot: iconDotGrey,
      dotSelected: iconDotDarkGrey,
    },
    size: {
      marker: {
        height: 23,
        width: 33,
      },
      dot: {
        height: 5,
        width: 5,
      },
      selected: {
        height: 36,
        width: 52,
      },
    },
  },
  store: {
    types: {
      default: iconStore,
      selected: iconStoreSelected,
      upcoming: iconStoreUpcoming,
      pin: 'tsla-icon-badge-pin',
      dot: iconDotRed,
      dotSelected: iconDotDarkGrey,
    },
    size: {
      marker: {
        height: 23,
        width: 33,
      },
      dot: {
        height: 5,
        width: 5,
      },
      selected: {
        height: 36,
        width: 52,
      },
    },
  },
  service: {
    types: {
      default: iconService,
      selected: iconServiceSelected,
      upcoming: iconServiceUpcoming,
      pin: 'tsla-icon-wrench-pin',
      dot: iconDotRed,
      dotSelected: iconDotDarkGrey,
    },
    size: {
      marker: {
        height: 23,
        width: 33,
      },
      dot: {
        height: 5,
        width: 5,
      },
      selected: {
        height: 36,
        width: 52,
      },
    },
  },
};
